/**
 * Province names and district data
 * Based on Observable notebook data
 */

export const PROVINCE_NAMES = new Map<string, string>([
  ["BUENOS AIRES", "Buenos Aires"],
  ["CAPITAL FEDERAL", "CABA"],
  ["CATAMARCA", "Catamarca"],
  ["CHACO", "Chaco"],
  ["CHUBUT", "Chubut"],
  ["CORDOBA", "Córdoba"],
  ["CORRIENTES", "Corrientes"],
  ["ENTRE RIOS", "Entre Ríos"],
  ["FORMOSA", "Formosa"],
  ["JUJUY", "Jujuy"],
  ["LA PAMPA", "La Pampa"],
  ["LA RIOJA", "La Rioja"],
  ["MENDOZA", "Mendoza"],
  ["MISIONES", "Misiones"],
  ["NEUQUEN", "Neuquén"],
  ["RIO NEGRO", "Río Negro"],
  ["SALTA", "Salta"],
  ["SAN JUAN", "San Juan"],
  ["SAN LUIS", "San Luis"],
  ["SANTA CRUZ", "Santa Cruz"],
  ["SANTA FE", "Santa Fe"],
  ["SANTIAGO DEL ESTERO", "Santiago del Estero"],
  ["TIERRA DEL FUEGO", "Tierra del Fuego"],
  ["TUCUMAN", "Tucumán"],
]);

export const DIPUTADOS_POR_PROVINCIA = new Map<
  string,
  { totales: number; renuevan: number }
>([
  ["BUENOS AIRES", { totales: 70, renuevan: 35 }],
  ["CAPITAL FEDERAL", { totales: 25, renuevan: 13 }],
  ["CATAMARCA", { totales: 5, renuevan: 3 }],
  ["CHACO", { totales: 7, renuevan: 4 }],
  ["CHUBUT", { totales: 5, renuevan: 2 }],
  ["CORDOBA", { totales: 18, renuevan: 9 }],
  ["CORRIENTES", { totales: 7, renuevan: 3 }],
  ["ENTRE RIOS", { totales: 9, renuevan: 5 }],
  ["FORMOSA", { totales: 5, renuevan: 2 }],
  ["JUJUY", { totales: 6, renuevan: 3 }],
  ["LA PAMPA", { totales: 5, renuevan: 2 }],
  ["LA RIOJA", { totales: 5, renuevan: 3 }],
  ["MENDOZA", { totales: 10, renuevan: 5 }],
  ["MISIONES", { totales: 7, renuevan: 3 }],
  ["NEUQUEN", { totales: 5, renuevan: 3 }],
  ["RIO NEGRO", { totales: 5, renuevan: 3 }],
  ["SALTA", { totales: 7, renuevan: 4 }],
  ["SAN JUAN", { totales: 6, renuevan: 3 }],
  ["SAN LUIS", { totales: 5, renuevan: 3 }],
  ["SANTA CRUZ", { totales: 5, renuevan: 3 }],
  ["SANTA FE", { totales: 19, renuevan: 9 }],
  ["SANTIAGO DEL ESTERO", { totales: 7, renuevan: 3 }],
  ["TIERRA DEL FUEGO", { totales: 5, renuevan: 2 }],
  ["TUCUMAN", { totales: 9, renuevan: 4 }],
]);

/**
 * Check if a province renews senators in this election
 */
export function renovaSenadores(_provincia: string): boolean {
  // Senadores se renuevan por tercios cada 2 años
  // This would need to be updated based on which provinces are renewing in 2025
  // For now, using a simplified approach - all provinces have 3 senators
  return true;
}
